import {
    createElementVNode as _$ce,
    map as _$ma,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Media} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', '向下滚动这个列表，观察媒体项进入浏览器可视区附近后再开始加载。', 16, 'media-demo-lazy-intro'),
        _$ce(2, 'div', (
            _$ma(this.get('eagerItems'), function($value, $key) {
                return _$ce(2, 'div', [
                    _$ce(2, 'div', $value.label, 0, 'media-demo-lazy-label'),
                    _$cc(Media, {
                        'type': $value.type,
                        'src': $value.src,
                        'poster': $value.poster,
                        'lazy': true,
                        'showNameTooltip': true,
                        'name': $value.name
                    })
                ], 4, 'media-demo-lazy-row', null, $value.key);
            }, $this)
        ), 8, 'media-demo-lazy-visible'),
        _$ce(2, 'div', (
            _$ma(this.get('lazyItems'), function($value, $key) {
                return _$ce(2, 'div', [
                    _$ce(2, 'div', $value.label, 0, 'media-demo-lazy-label'),
                    _$cc(Media, {
                        'type': $value.type,
                        'src': $value.src,
                        'poster': $value.poster,
                        'lazy': true,
                        'showNameTooltip': true,
                        'name': $value.name
                    })
                ], 4, 'media-demo-lazy-row', null, $value.key);
            }, $this)
        ), 8, 'media-demo-lazy')
    ], 4, 'media-demo-lazy-demo');
};